import {SxType} from "@baseTypes/sx/sxTypes";
import {HEIGHT_TOP_SIDEBAR_SINGLE_VOYAGE, ROOT_GAP_SINGLE_VOYAGE} from "@containers/singleVoyage/views/constants/size";
import {HEADER_HEIGHT_DESKTOP} from "@view/constants/size";
import {SV_DARK, SV_LIGHT} from "@containers/singleVoyage/views/constants/theme";

export const sx:SxType = {
    root:{
        display:'flex',
        padding:ROOT_GAP_SINGLE_VOYAGE,
        gap:ROOT_GAP_SINGLE_VOYAGE,
        height:'100%',
        maxHeight:`calc(100vh - ${HEIGHT_TOP_SIDEBAR_SINGLE_VOYAGE} - ${HEADER_HEIGHT_DESKTOP})`,
        '.lightTheme &': {
            backgroundColor: SV_LIGHT.bg,
        },
        '.darkTheme &': {
            backgroundColor: SV_DARK.bg,
        },
    }
}
